module.exports = __webpack_public_path__ + "img/ruffle_length.1517ebf5.png";